import styled from 'styled-components';

import TableWithColumns from './TableWithColumns';

const Wrapper = styled.div`
  border-top: 4px solid ${({ theme }) => theme.custom.colors.brand};
`;

/**
 * @todo consolas font for headers
 * @todo change texts
 */
export default function TableContainer({ exporting }) {
  return (
    <Wrapper>
      <TableWithColumns exporting={exporting} />
    </Wrapper>
  );
}
